/**
 * Generated bundle index. Do not edit.
 */
export { MatProgressSpinnerModule, MatProgressSpinnerBase, _MatProgressSpinnerMixinBase, MatProgressSpinner, MatSpinner } from './public-api';
//# sourceMappingURL=index.js.map